import createStyleLink from './create-style-link';

const injectCssSources = (targetDocument, dependencies, attributes = {}, target) => {
  const attributesEntry = Object.entries(attributes);

  dependencies.forEach((src) => {
    if (targetDocument.querySelector(`link[href="${src}"]`)) return;

    const link = createStyleLink(targetDocument, src);

    attributesEntry.forEach(([attributeName, attributeValue]) => {
      link.setAttribute(attributeName, attributeValue);
    });

    target.element.insertAdjacentElement(target.position, link);
  });
};

export default injectCssSources;
